import Lightbox from 'bs5-lightbox'

document.addEventListener('turbo:load', () => {
  addLightboxListeners()
  displaySeatingLinkLightbox()
})

if (window.name === 'derby') {
  document.addEventListener('shown.bs.modal', e => {
    if (!e.target.classList.contains('lightbox')) return
    e.target.querySelectorAll('.ratio').forEach(el => el.classList.remove('ratio', 'ratio-16x9'))
    e.target.querySelectorAll('.spinner-border').forEach(el => el.closest('.position-absolute')?.remove())
    if (e.target.dataset.lightboxBg)
      e.target.querySelectorAll('[style*="background-color"]').forEach(el => el.style.backgroundColor = e.target.dataset.lightboxBg)
  })
}

function addLightboxListeners() {
  let lightboxes = document.querySelectorAll('[data-toggle="custom-lightbox"]')

  Array.from(lightboxes).forEach(box => {
    box.addEventListener('click', function(event) {
      event.preventDefault()
      let lightbox = new Lightbox(box)
      if (box.dataset.lightboxType === 'map' && window.name === 'derby') lightbox.modalElement.dataset.lightboxBg = 'white'
      lightbox.show()
    })
  })
}

function displaySeatingLinkLightbox() {
  let box = document.querySelector('.seating--link')
  if(box && box.dataset.toggle != 'custom-lightbox') { // dont duplicate
    box.addEventListener('click', (e) => {
      e.preventDefault()
      let lightbox = new Lightbox(box)
      if (box.dataset.lightboxType === 'map' && window.name === 'derby') lightbox.modalElement.dataset.lightboxBg = 'white'
      lightbox.show()
    })
  }
}